import React, { useState } from "react";
import moment from "moment";
import { Form } from "react-bootstrap";
import Select from "../../components/Select";
import InfoBox from './InfoBox'

import search_button from "../../transactions/resources/search_button.png";
import enquiry_button from "../../transactions/resources/enquiry_button.png";
import CommentButton from "../../components/TransactionComments/CommentButton";
import Api from "../../utils/Api";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function DesktopTransactionApprovalItem(props) {
    const item = {
        id: props.item.id,
        time: moment(props.item.time).format("DD-MM-YY"),
        description: props.item.description,
        remarks: props.item.remarks || undefined,
        categoryId: props.item.categoryId,
        amount: props.item.amount,
        totalAmount: props.item.totalAmount || undefined,
        isCredit: props.item.isCredit,
        type: props.item.type,
        identifier: props.item.accountNumber ? props.item.accountNumber : props.item.creditCard,
        predictionGrade: props.item.predictionGrade,
        tags: props.item.tags || undefined,
        expanded: false,
        approvalMode: props.approvalMode,
        reccuringData: props.item.reccuringData,
        editMode: false,
    };

    const [categoryId, setCategoryId] = useState(item.categoryId);
    const [categoryDescription, setCategoryDescription] = useState(item.categoryDescription);
    const [tags, setTags] = useState(item.tags);
    const [remarks, setRemarks] = useState(item.remarks);

    const history = useHistory();

    const getCategoryDescription = (categoryId) => {
        const match = props.categoryLookup.find(function (item) {
            return item.id === categoryId;
        });

        if (match) {
            return match.description;
        } else {
            return "קטגוריה חסרה";
        }
    }

    const handleSaveClick = async () => {
        const updateItem = {
            id: item.id,
            type: item.type,
            remarks: remarks,
            categoryId: categoryId,
            tags
        };

        const { response } = await Api.post("/api/approveTransaction", updateItem);

        if (response.success) {
            props.showSaveSuccess();
            props.removeTransactionCallback(item.id);
        } else {
            props.showSaveError();
        }
    }

    const handleDeleteClick = async () => {
        const response = await Api.deleteTransaction(item.id, item.type);
        if (response.status === 200) {
            props.showDeleteSuccess();
            props.removeTransactionCallback(item.id);
        } else {
            props.showDeleteError();
        }
    }

    const findSimilarClick = async () => {
        history.push({
            pathname: "/content/archive",
            search: `?transaction=${item.description}`
        });
    }

    const handleCategoryChanged = (selectedCategoryId) => {
        setCategoryId(selectedCategoryId);
        setCategoryDescription(getCategoryDescription(selectedCategoryId));
    };

    const handleTagChanged = (selectedTagIds) => {
        setTags(selectedTagIds);
    };

    const getTransactionSummary = function () {
        const summary =
            "** בירור עסקה ** " +
            "\n" +
            "תאריך: " +
            item.time +
            "\n" +
            "תיאור: " +
            item.description +
            "\n" +
            "מחיר: " +
            item.amount +
            "\n" +
            "קוגוריה מוצעת: " +
            item.categoryDescription;

        const encodedSummary = encodeURI(summary);
        return encodedSummary;
    };

    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    }

    const handleCheckboxChange = (event) => {
        props.onSelectionChange(item.id, event.target.checked);
    }

    const sendWhatsappSummary = `whatsapp://send?text=${getTransactionSummary()}`;
    const searchLink = `https://www.google.co.il/search?q=${item.description}`;

    const amountColor = item.isCredit ? "#23d188" : "#ed578b";
    const amountRow = item.totalAmount
        ? `(${item.totalAmount}) ${item.amount}₪`
        : `${item.amount}₪`;

    return (
        <div style={{ direction: "rtl" }}>
            <div
                style={{
                    display: "flex",
                    borderBottom: "solid",
                    borderColor: "lightgray",
                    borderWidth: "1px",
                    padding: "20px"
                }}
            >
            {props.selectionMode && (
                <div style={{
                    minWidth: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderLeft: "lightgray solid 1px",
                    marginLeft: "10px"
                }}>
                    <input
                        type="checkbox"
                        checked={props.isSelected || false}
                        onChange={handleCheckboxChange}
                        style={{
                            width: "18px",
                            height: "18px",
                            cursor: "pointer"
                        }}
                    />
                </div>
            )}
            <div style={{
                minWidth: "50px",
                borderLeft: "lightgray solid 1px", marginLeft: "20px",
                display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px"
            }}>
                <CommentButton
                    transactionId={item.id.toString()}
                    transactionDescription={item.description}
                    transactionAmount={item.amount}
                    transactionType={item.type}
                    hasComments={props.item.hasComments}
                />
                <a href={sendWhatsappSummary} style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "32px", height: "32px" }}>
                    <img src={enquiry_button} style={{ width: "28px", height: "28px", objectFit: "contain" }} />
                </a>
                <a href={searchLink} target="_blank" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "32px", height: "32px" }}>
                    <img src={search_button} style={{ width: "28px", height: "28px", objectFit: "contain" }} />
                </a>
            </div>

            <div style={{
                width: "150px", display: "flex", flexFlow: "column",
                borderLeft: "lightgray solid 1px", marginLeft: "20px", alignSelf: "center"
            }}>
                <button
                    type="button"
                    onClick={handleSaveClick}
                    className="btn btn-primary btn-md"
                    style={{
                        width: "70px",
                        height: "32px",
                        backgroundColor: "#74bf85",
                        borderColor: "#74bf85",
                        lineHeight: "1",
                        fontSize: "14px",
                        padding: "0"
                    }}
                >
                    אשר
                </button>

            </div>

            <div style={{
                width: "150px", display: "flex", flexFlow: "column",
                borderLeft: "lightgray solid 1px", marginLeft: "10px", alignSelf: "center"
            }}>
                <button
                    type="button"
                    onClick={findSimilarClick}
                    className="btn btn-info btn-md"
                    style={{
                        width: "70px",
                        height: "32px",
                        lineHeight: "1",
                        fontSize: "14px",
                        padding: "0",
                        marginBottom: "8px"
                    }}
                >
                    דומות
                </button>

                <button
                    type="button"
                    onClick={handleDeleteClick}
                    className="btn btn-danger btn-md"
                    style={{
                        width: "70px",
                        height: "32px",
                        lineHeight: "1",
                        fontSize: "14px",
                        padding: "0"
                    }}
                >
                    מחק
                </button>
            </div>

            <div style={{ minWidth: "180px", textAlign: "center", borderLeft: "lightgray solid 1px", marginLeft: "40px" }}>
                <h6
                    style={{
                        color: "darkgray",
                    }}
                >
                    {item.time}
                </h6>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    {(item.reccuringData) &&
                        <InfoBox size={20}
                            name={item.reccuringData.name}
                            description={item.reccuringData.description}
                            category={getCategoryDescription(item.reccuringData.categoryId)}
                            type={item.reccuringData.type}
                        />
                    }
                    <h6 style={{ marginRight: "10px" }}>{item.description}</h6>
                </div>

                <h6 style={{ color: amountColor }}>
                    {amountRow}
                </h6>
                <h6>{item.identifier}</h6>
            </div>

            <div style={{ borderLeft: "lightgray solid 1px", marginLeft: "10px" }}>
                <div style={{ marginBottom: "15px", marginLeft: "45px", display: "flex" }}>
                    <h7 style={{ fontWeight: "bold", width: "65px" }}>קטגוריה</h7>
                    <Select
                        options={props.categoryLookup}
                        selected={item.categoryId}
                        onSelect={handleCategoryChanged}
                        closeOnSelect={true}
                        placeholder="קטגוריה"
                        isSearchable={true}
                    />
                </div>

                <div style={{ marginBottom: "15px", marginLeft: "45px", display: "flex" }}>
                    <h7 style={{ fontWeight: "bold", width: "65px" }}>תגיות</h7>
                    <Select
                        options={props.tagLookup}
                        selected={item.tags}
                        onSelect={handleTagChanged}
                        multi={true}
                        placeholder="תגיות"
                        isSearchable={true}
                    />
                </div>
            </div>
            <div style={{ marginRight: "20px" }}>
                <div style={{ marginBottom: "15px", marginLeft: "45px" }}>
                    <h7 style={{ fontWeight: "bold", width: "65px" }}>הערות</h7>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Control style={{ resize: 'none' }} value={item.remarks} as="textarea" rows={3} onChange={handleRemarksChange} />
                        </Form.Group>
                    </Form>
                    {/* <input
                        type="text"
                        value={item.remarks}
                        onChange={handleRemarksChange}
                        style={{ borderWidth: "1px" }}
                    ></input> */}
                </div>
                {/* <h5>{item.predictionGrade}</h5> */}
            </div>
            </div>
        </div>
    );
}